import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function ProductDiscount() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();

  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (sn) => sn.row.index + 1,
    },
    {
      header: languageHelper("Product Name") || "Product Name",
      // accessorKey: "ProductName",
      cell: (product) => product.row.original.food_menu?.[0]?.name,
    },
    {
      header: languageHelper("Start Date") || "Start Date",
      accessorKey: "start_date",
    },
    {
      header: languageHelper("End Date") || "End Date",
      accessorKey: "end_date",
    },
    {
      header: languageHelper("Amount") || "Amount",
      accessorKey: "discount_amount",
    },
    {
      header: languageHelper("Discount Type") || "Discount Type",
      accessorKey: "dis_type",
      cell: (row) =>
        row.getValue() === "percentage"
          ? languageHelper("Percentage") || "Percentage"
          : row.getValue() === "amount"
            ? languageHelper("Amount") || "Amount"
            : "",
    },
    {
      header: languageHelper("Use Discount") || "Use Discount",
      accessorKey: "use_discount",
      cell: (row) =>
        row.getValue() === "one_time"
          ? languageHelper("One Time") || "One Time"
          : row.getValue() === "regular"
            ? languageHelper("Regular") || "Regular"
            : "",
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/discounts/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchProductDiscount();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`AddProductDiscountForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        setDeleteId(id);
      },
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Product Discount"),
      path: "AddProductDiscountForm",
    },
  ];

  const fetchProductDiscount = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/discounts`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          includes: "product",
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, user?.user.outlet_id]);

  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchProductDiscount);
  }, [fetchProductDiscount]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={languageHelper("Product Discount")}
        buttonData={buttonData}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}

      {deleteId && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setDeleteId(null)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-[#774d96] font-semibold text-xl text-center">
                {languageHelper("Alert!") || "Alert!"}
              </h1>
              <p className="text-center text-gray-700">
                {languageHelper("Are you sure?")}
              </p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setDeleteId(null)}
              >
                {languageHelper("No") || "No"}
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                {languageHelper("Yes") || "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default ProductDiscount;
